(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nulterra-about-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nulterra-about-film')) {
    customElements.define('nulterra-about-film', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.video.muted = true;
        this.video.controls = false;
        this.syncPlayback = () => {
          if (document.hidden || !this.inView || this.motion.matches || navigator.connection?.saveData) {
            this.video.pause();
          } else {
            this.video.play().catch(() => {});
          }
        };
        document.addEventListener('visibilitychange', this.syncPlayback, options);
        this.motion.addEventListener('change', this.syncPlayback, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nulterra-hunt"] && !Shopify.designMode) return;
  try {
    (() => {
    const boot = () => {
      const root=document.querySelector('[data-n-hunt]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
      const labels=JSON.parse(root.querySelector('[data-hunt-labels]').textContent),key='nulterra-hunt-v1',ids=['contact','stairway','bigfoot'];
      let state={active:false,found:[]},storageError=false,badgeFile=null,badgePromise=null,returnFocus=null;
      const dialog=root.querySelector('[data-hunt-dialog]');
      const read=()=>{try{const saved=JSON.parse(localStorage.getItem(key)||'null');state={active:saved?.active===true,found:[...new Set((Array.isArray(saved?.found)?saved.found:[]).filter(id=>ids.includes(id)))]};}catch{state={active:false,found:[]};}};
      const save=()=>{try{if(state.active)localStorage.setItem(key,JSON.stringify(state));else localStorage.removeItem(key);storageError=false;return true;}catch{storageError=true;return false;}};
      const text=()=>labels.status.replace('{count}',state.found.length);
      const render=()=>{
        const complete=state.active&&state.found.length===3;
        document.querySelectorAll('[data-hunt-status]').forEach(el=>el.textContent=storageError?labels.storage:state.active?text():'');
        document.querySelectorAll('[data-hunt-start]').forEach(el=>el.hidden=state.active);
        document.querySelectorAll('[data-hunt-stop]').forEach(el=>el.hidden=!state.active);
        document.querySelectorAll('[data-hunt-badge]').forEach(el=>el.hidden=!complete);
        document.querySelectorAll('[data-hunt-clues]').forEach(el=>el.hidden=!state.active);
        document.querySelectorAll('[data-clue]').forEach(el=>el.classList.toggle('is-found',state.found.includes(el.dataset.clue)));
        root.querySelector('[data-hunt-hud]').hidden=!state.active||root.dataset.cart==='true';
        root.querySelector('[data-hunt-counter]').textContent=text();
        const marker=root.querySelector('[data-hunt-visitor]');if(marker)marker.closest('[data-hunt-place]').hidden=!state.active||state.found.includes(marker.dataset.huntVisitor);
      };
      const close=()=>{dialog.close();if(returnFocus?.offsetParent)returnFocus.focus();else root.querySelector('[data-hunt-hud] a')?.focus();};
      const prepareBadge=()=>{
        if(badgeFile)return Promise.resolve(badgeFile);
        if(!badgePromise)badgePromise=fetch(root.querySelector('[data-hunt-badge-image]').src,{credentials:'omit'}).then(r=>{if(!r.ok)throw new Error('Badge image unavailable');return r.blob();}).then(blob=>{badgeFile=new File([blob],'nulterra-earth-visitor.png',{type:blob.type||'image/png'});return badgeFile;}).catch(()=>{badgePromise=null;return null;});
        return badgePromise;
      };
      const open=()=>{if(state.found.length!==3||!state.active)return;returnFocus=document.activeElement;root.querySelector('[data-hunt-share-status]').textContent='';if(!dialog.open)dialog.showModal();prepareBadge();};
      document.addEventListener('click',async e=>{
        const button=e.target.closest('button');if(!button)return;
        if(button.matches('[data-hunt-start],[data-hunt-replay]')){state={active:true,found:[]};if(!save())state.active=false;if(dialog.open)close();render();if(state.active)document.querySelector('[data-hunt-clues] a')?.focus();}
        else if(button.matches('[data-hunt-stop]')){state={active:false,found:[]};save();if(dialog.open)close();render();root.querySelector('[data-hunt-announcement]').textContent=labels.cancelled;document.querySelector('[data-hunt-start]')?.focus();}
        else if(button.matches('[data-hunt-visitor]')&&state.active){const id=button.dataset.huntVisitor;if(!ids.includes(id)||state.found.includes(id))return;state.found.push(id);save();render();root.querySelector('[data-hunt-announcement]').textContent=labels.collected+'. '+text();if(state.found.length===3)open();else root.querySelector('[data-hunt-hud] a').focus();}
        else if(button.matches('[data-hunt-badge]'))open();
        else if(button.matches('[data-hunt-close]'))close();
        else if(button.matches('[data-hunt-download]')){
          const file=await prepareBadge();const a=document.createElement('a');a.href=file?URL.createObjectURL(file):root.querySelector('[data-hunt-badge-image]').src;a.download='nulterra-earth-visitor.png';if(!file)a.target='_blank';a.rel='noopener';document.body.append(a);a.click();a.remove();if(file)setTimeout(()=>URL.revokeObjectURL(a.href),30000);root.querySelector('[data-hunt-share-status]').textContent=labels.downloaded;
        }else if(button.matches('[data-hunt-share]')){
          const fileData=badgeFile?{files:[badgeFile],title:'Nulterra Earth Visitor',text:labels.share_text}:null;
          try{if(!navigator.share)throw new Error('Sharing unavailable');await navigator.share(fileData&&navigator.canShare?.(fileData)?fileData:{title:'Nulterra Earth Visitor',text:labels.share_text,url:new URL('/#NulterraMission',location.origin).href});}catch(err){if(err.name!=='AbortError')root.querySelector('[data-hunt-share-status]').textContent=labels.share_error;}
        }
      });
      dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
      window.addEventListener('storage',e=>{if(e.key===key){read();render();if(!state.active&&dialog.open)close();}});
      window.addEventListener('nulterra:explore-ready',render);document.addEventListener('shopify:section:load',render);
      read();render();
    };if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nulterra-ufo-sky"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nulterra-ufo-sky')) {
    customElements.define('nulterra-ufo-sky', class extends HTMLElement {
      constructor() {
        super();
        this.paused = false;
        this.handleToggle = this.toggleMotion.bind(this);
        this.handleVisibility = () => this.toggleAttribute('data-tab-hidden', document.hidden);
      }

      connectedCallback() {
        this.button = this.querySelector('.n-ufo-toggle');
        if (!this.button) return;
        try {
          this.paused = sessionStorage.getItem('nulterra-ufo-paused') === 'true';
        } catch (_) {}
        this.button.addEventListener('click', this.handleToggle);
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.updateState();
        this.handleVisibility();
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleToggle);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      toggleMotion() {
        this.paused = !this.paused;
        this.updateState();
        try {
          sessionStorage.setItem('nulterra-ufo-paused', String(this.paused));
        } catch (_) {}
      }

      updateState() {
        this.toggleAttribute('data-paused', this.paused);
        const label = this.paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel;
        this.button.querySelector('[data-ufo-label]').textContent = label;
        this.button.setAttribute('aria-label', label);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
